export class AppPaths {
  static readonly NetworkConnectionCheckUrl = '/api/app/application-health-check/check-health';
}
